import React from "react";
import "@/stylesheets/components/generic/radioButton.scss";

export interface IListObj {
  href?: string | undefined;
  value: number | string;
  display: string;
  primary?: boolean;
}

export interface RadioButtonProps {
  list: IListObj; //list of all options in radio btn
  name: string;
  selected?: number | string; // selected value
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void; // function to be called on change
  moduleName?: string;
  disabled?: boolean;
  avoidchekmark?: boolean;
  className?: string;
  textClass?: string;
}

const RadioButton: React.FC<RadioButtonProps> = (props) => {
  const moduleName = props.moduleName ? props.moduleName : "";

  return (
    <div className={`radio-button ${props.className}`}>
      <label className={"radio_btn " + moduleName}>
        <input
          type="radio"
          value={props.list.value}
          name={props.name}
          key={props.list.value}
          checked={props.selected === props.list.value}
          onChange={props.onChange}
          disabled={props.disabled ? props.disabled : false}
        />
        {props.avoidchekmark ? <></> : <span className="checkmark"></span>}

        <span
          className={`${
            props.textClass
              ? `disp_val ${props.textClass}`
              : "disp_val DMSansMedium_16_500 txt_blackOne1"
          }`}
        >
          {props.list.display}
        </span>
      </label>
    </div>
  );
};

export default RadioButton;
